import { Button, Modal, ModalHeader, ModalBody } from '@evertrue/et-components';
import BioContactInfo from 'apps/profile/components/bio-contact-info';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import EmailPromptsList from './bio-email-prompts-list';
import { useContactModalContext } from '../contexts/contact-modal-context';

const ContactModal = ({ contact = {}, hasAI = true, handleOpenEmailTemplate = () => null }) => {
  const firstName = get(contact, 'properties.name_first.value');
  const { contactModalIsOpen, openContactModal, closeContactModal } = useContactModalContext();

  return (
    <>
      <Button type="secondary" onClick={openContactModal}>
        <span className="fs-exclude-data">{`Contact ${firstName}`}</span>{' '}
      </Button>
      <Modal isOpen={contactModalIsOpen} onClose={closeContactModal} size="large">
        <ModalHeader title={hasAI ? 'Contact and Suggested Outreach' : 'Contact'} closeModal={closeContactModal} />
        <ModalBody>
          <div style={{ display: 'flex' }}>
            <BioContactInfo contact={contact} hasHeader={false} closeModal={closeContactModal} />
            {hasAI ? (
              <EmailPromptsList onListItemClick={handleOpenEmailTemplate} requestHide={closeContactModal} />
            ) : null}
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

ContactModal.propTypes = {
  contact: PropTypes.object,
  hasAI: PropTypes.bool,
  handleOpenEmailTemplate: PropTypes.func,
};

export default ContactModal;
